module.exports = __webpack_public_path__ + "static/media/banner_subimage.9d347885.png";